const renderBreadcrumbs = (breadcrumbs: any[], currentLocation: string) => {
	if (breadcrumbs.length === 0) {
		return null;
	}

	return (
		<div>
			{breadcrumbs.map((b: any) => (
				<span>
					<a href={b.path}>{b.label}</a>
					<span>/</span>
				</span>
			))}
			<span>{currentLocation}</span>
		</div>
	);
};

export default renderBreadcrumbs;
